export const REDUCER_NAME = "betaFeatures";

export const ACTION_TYPES = {
  getBetaFeatures: `${REDUCER_NAME}/getBetaFeatures`,
  setBetaFeatures: `${REDUCER_NAME}/setBetaFeatures`,
};
